@if (chartsCountSg() === 1) {
  <!-- In case that there is only one chart, we want to display it on whole
  widget, and to avoid calculations for grid layout, only one chart is displayed
  without any classes-->
  <atn-ds-chart [chart]="chartsSg()[0]" />
} @else {
  <div
    #barChartsContainer
    class="bar-chart-grid-container"
    [style.--bar-chart--min-width]="minWidth"
    [style.--bar-chart--min-height]="minHeight"
    [style.--bar-charts--max-columns]="columnsCountSg()"
    [style.--bar-charts--rows]="rowsCountSg()"
    [style.--bar-chart--container-height]="containerHeightSg()"
  >
    @for (chart of chartsSg(); track $index) {
      <atn-ds-chart [chart]="chart" />
    }
  </div>
}
